// get reader-data for card
export function getRating(data) {
  if (!data?.acf?.reader_rating) {
    return;
  }

  let counter = 0;
  const readerRating = data.acf.reader_rating;

  if (readerRating) {
    readerRating.forEach((e) => {
      counter += parseInt(e.reader_rating_stars, 10);
    });
    return (counter / readerRating.length).toFixed(1);
  }

  return -1;
}
